import React from 'react';
import classnames from 'classnames';
import { OrderItemPropType } from '../../prop-types/order-item';
import ItemDisplay from './components/item-display.component';
import Quantity from './components/item-quantity.component';

import style from './style.module.less';

const ShipmentDetailsLineItem = ({ orderItem = {} }) => {
  const { quantity = 0, name, sku, attributes, productThumbnailUrl, dangerousGoods } = orderItem;

  const isClassifiedAsDangerousGoods = dangerousGoods?.length > 0;

  return (
    <>
      <div className={classnames(style.tile, style['item-display-wrapper'])}>
        <ItemDisplay
          attributes={attributes}
          className={style['item-display']}
          isClassifiedAsDangerousGoods={isClassifiedAsDangerousGoods}
          name={name}
          productThumbnailUrl={productThumbnailUrl}
          sku={sku}
        />
      </div>
      <div className={classnames(style.tile, style['quantity-column'], style['border-right'])}>
        <div className={classnames(style['content-wrapper'], style.row)}>
          <Quantity quantity={quantity} />
        </div>
      </div>
    </>
  );
};

ShipmentDetailsLineItem.propTypes = {
  orderItem: OrderItemPropType.isRequired,
};

export default ShipmentDetailsLineItem;
